import {Icon, IconProps} from '@chakra-ui/react';

export const RulesIcon = (props: IconProps) => (
  <Icon width="16px" height="17px" viewBox="0 0 16 17" fill="none" {...props}>
    <path
      d="M14.6666 7.16671V10.5C14.6666 13.8334 13.3333 15.1667 9.99992 15.1667H5.99992C2.66659 15.1667 1.33325 13.8334 1.33325 10.5V6.50004C1.33325 3.16671 2.66659 1.83337 5.99992 1.83337H9.33325"
      stroke="#877C2B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6666 7.16671H11.9999C9.99992 7.16671 9.33325 6.50004 9.33325 4.50004V1.83337L14.6666 7.16671Z"
      stroke="#877C2B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66675 9.16663H8.66675"
      stroke="#877C2B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66675 11.8334H7.33342"
      stroke="#877C2B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
